import React from 'react';
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import Spinner from 'layouts/public/spinner/Spinner'

class MembersStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
        return { loading: true };
    }

    componentDidMount() {
		this.get();
    }

	get = () => {
        new API().post(APIModules.Admin.url('/sponsorDashboard/getMembersStatus'), null,
            {
                success: (r) => {
                    this.setState({...r.data, loading: false});
                }
			});
    }

	render() {
		if (this.state.loading)
			return <Spinner />

		return (
			<Table condensed>
				<thead>
					<tr>
						<th className="col-md-2">Current</th>
						<th className="col-md-2">Active</th>
						<th className="col-md-2">Expired</th>
						<th className="col-md-2">Inactive</th>
					</tr>
				</thead>
				<tbody>
				<tr>
					<td className="react-grid-Cell">
						{this.state.current > 0 ?
							<Link to={'/admin/sponsorSetup?expired=false'}>
								{this.state.current}
							</Link>
						:
							<span>-</span>
						}	
					</td>
					<td className="react-grid-Cell">
						{this.state.active > 0 ?
							<Link to={'/admin/sponsorSetup?active=true'}>
								{this.state.active}
							</Link>
						:
							<span>-</span>
						}
					</td>
					<td className="react-grid-Cell">
						{this.state.expired > 0 ?
							<Link to={'/admin/sponsorSetup?expired=true'}>
								{this.state.expired}
							</Link>
						:
							<span>-</span>
						}	
					</td>
					<td className="react-grid-Cell">
						{this.state.inactive > 0 ?
							<Link to={'/admin/sponsorSetup?active=false'}>
								{this.state.inactive}
							</Link>
						:
							<span>-</span>
						}
					</td>
				</tr>
				</tbody>
			</Table>
		)
	}
}

export default MembersStatus;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminSponsorDashboard/membersStatus/MembersStatus.js